import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { handleCheckedStatus } from '@helpers/versions_helper';
import UploadArea from '@components/common/filestack_uploader/upload_area';
import VersionUppy from '@components/common/uppy/version_uppy';

export default class CheckinCheckout extends Component {
  state = {
    checkinCheckoutNote: '',
  }

  handleToggleCheckinCheckout = () => {
    const { checkinCheckoutNote } = this.state;

    this.setState({ checkinCheckoutNote: '' });
    this.props.toggleCheckinCheckout(checkinCheckoutNote);
  }

  renderActionButton() {
    const {
      asset, checkinCheckoutUpdating, isLoading, joinedEvents, updateTab,
      updateVersionUploading, visibleAttachment
    } = this.props;
    const { checkedinStatus } = handleCheckedStatus(joinedEvents);

    if (checkedinStatus) {
      return (
        <button
          className="button primary md"
          disabled={checkinCheckoutUpdating || isLoading}
          onClick={() => this.handleToggleCheckinCheckout()}
          type="button"
        >
          {isLoading ? t('loading...') : t('Check Out')}
        </button>
      );
    }

    const uploadOptions = {
      maxFiles: 1,
      onFileUploadStarted: () => updateVersionUploading({ versionUploading: true })
    };

    if (BFG.hasFeature('uppy_uploader_features')) {
      return (
        <VersionUppy
          attachmentKey={visibleAttachment.id}
          assetKey={asset.id}
          handleToggleCheckinCheckout={this.handleToggleCheckinCheckout}
          updateTab={updateTab}
          updateVersionUploading={updateVersionUploading}
        />
      );
    }

    return (
      <UploadArea
        asset={asset}
        assetKey={asset.id}
        attachment={visibleAttachment}
        handleToggleCheckinCheckout={this.handleToggleCheckinCheckout}
        options={uploadOptions}
        type="button"
        uniqDomElement={`version-status-uploader-checkin-${visibleAttachment.id}`}
        updateTab={updateTab}
        updateVersionUploading={updateVersionUploading}
        uploadType="attachment-version-status"
      />
    );
  }

  render() {
    const { isLoading, joinedEvents } = this.props;
    const { checkedinStatus, email, updatedAt, userKey } = handleCheckedStatus(joinedEvents);
    const inCopy = t('(Optional) Let your teammates know why you’re checking in this attachment...');
    const outCopy = t('(Optional) Let your teammates know why you’re checking out this attachment...');
    let checkinCheckoutCopy;
    let feedbackCopy = '';

    if (isLoading) {
      checkinCheckoutCopy = t('loading...');
    } else {
      checkinCheckoutCopy = checkedinStatus ? t('active') : t('checked out');

      if (checkedinStatus) {
        feedbackCopy = <h4>{t('To update it outside of Brandfolder, check it out below. Don’t forget to promptly check it back in here when it’s been updated.')}</h4>;
      } else if (BFG.currentUser.user_id === userKey) {
        feedbackCopy = <h4>{`${t('You checked this attachment out')} ${moment(updatedAt).fromNow()}. ${t('Please promptly check it back in below so your teammates have access to the most current version.')}`}</h4>;
      } else {
        feedbackCopy = (
          <h4>
            <a className="checkedout-email" href="mailto:INPUT-EMAIL">{email}</a>
            {`${t('checked this attachment out')} ${moment(updatedAt).fromNow()}. ${t('Please follow up with them to retrieve the most current version.')}`}
          </h4>
        );
      }
    }

    return (
      <section className="checkin-checkout-container">
        <h3 className="header-copy">
          {t('This attachment is')}
          <span className="attachment-status-copy">
            {checkinCheckoutCopy}
            .
          </span>
        </h3>
        {feedbackCopy}
        <div className="checkin-checkout-actions-container">
          <input
            className="checkin-checkout-note-input inputs"
            onChange={(e) => this.setState({ checkinCheckoutNote: e.target.value })}
            placeholder={checkedinStatus ? inCopy : outCopy}
            type="text"
            value={this.state.checkinCheckoutNote}
          />
          {this.renderActionButton()}
        </div>
      </section>
    );
  }
}

CheckinCheckout.propTypes = {
  asset: PropTypes.shape({
    asset_key: PropTypes.string
  }).isRequired,
  visibleAttachment: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  checkinCheckoutUpdating: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  joinedEvents: PropTypes.arrayOf(PropTypes.shape({ updatedAt: PropTypes.string })).isRequired,
  toggleCheckinCheckout: PropTypes.func.isRequired,
  updateTab: PropTypes.func.isRequired,
  updateVersionUploading: PropTypes.func.isRequired
};
